module.exports = __webpack_public_path__ + "img/Pixel3Frame-1540h.6b2e3833.webp";